<template>
    <transition name="layout-fade">
        <v-layout wrap class="layout-add--max_width">
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    export default {
        name: 'bookingLayout'
    }
</script>
